import React from 'react';
//import { WithContext as ReactTags } from 'react-tag-input';
import { ButtonRadio, Field, Textarea } from '../Common';

const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

export default class ObituaryForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.data.id ? props.data.id : '',
            idBeneficiaire: props.data.idBeneficiaire ? props.data.idBeneficiaire : '',
            displayObituary: props.data.displayObituary ,
            tags: [],
            newspapers: props.data.newspapers && props.data.newspapers.length > 0  ? props.data.newspapers : [''],
            obituaryText: props.data.obituaryText ? props.data.obituaryText : '',
            error: {
                newspapers: '',
                obituaryText: ''
            }
        }
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
    }

    handleOnChange = (key, e) => {
        const value = e.target.value;
        if ( key === 'obituaryText') {
            this.setState(prevState => ({ 
                ...prevState,
                [key]: value,
                error : {
                    ...prevState.error,
                    obituaryText: ''
                }
            }));
        } else if ( key == 'displayObituary' ) {
            this.setState(prevState => ({ 
                ...prevState,
                displayObituary: value == "1",
                error : {
                    ...prevState.error,
                    obituaryText: ''
                }
            }));
        } else {
            this.setState(() => ({ [key]: value }));
        }
    }

    newspapersOnChange = (e) => {
        const value = e.target.value;
        const index = e.target.name;
        let newspapers = [...this.state.newspapers]
        newspapers[index] = value
        this.setState(prevState => ({ 
            ...prevState,
            newspapers,
            error: {
                ...prevState.error,
                newspapers: ''
            }
        }));
    }

    handleDelete(i) {
        const { tags } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        });
    }

    handleAddition(tag) {
        this.setState(state => ({ tags: [...state.tags, tag] }));
    }
    addNewspapers = () => {
        this.setState(prevState => ({
            newspapers: [...prevState.newspapers, '']
        }));
    }
    removeItem = (index) => {
        //console.log(index);
        let newspapers = [...this.state.newspapers]
        newspapers.splice(index, 1);
        this.setState(() => ({ newspapers }));
    }

    onObituarySubmit = (e) => {
        e.preventDefault();
        let newspapers = (!this.state.newspapers) ? ' is-invalid' : '';
        let total = 0;
        for ( let i = 0, len = this.state.newspapers.length; i < len; i++ ) {
            if ( this.state.newspapers[i] != '' ) {
                total += 1;
            }
        }
        if ( total == 0 ) {
            newspapers = ' is-invalid';
        }
        newspapers = (this.state.newspapers.length == 1 &&  this.state.newspapers[0] == '') ? ' is-invalid' : newspapers;
        const obituaryText = (!this.state.obituaryText) ? ' is-invalid' : '';
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                newspapers,
                obituaryText,
            }
        }))
        if ( !this.state.displayObituary || (!newspapers && !obituaryText)) {
            this.props.onObituarySubmit({
                newspapers: !this.state.displayObituary ? ['']: this.state.newspapers,
                obituaryText: !this.state.displayObituary ? '': this.state.obituaryText,
                displayObituary: this.state.displayObituary,
                id: this.state.id,
                idBeneficiaire: this.state.idBeneficiaire
            });
        }
    }


    render() {
        return (
            <form onSubmit={this.onObituarySubmit} className="obituary-form">
                <div className="row">
                    <div className="col-sm-5 obituary-img">
                        <img src='/images/avis-deces-lg.png' alt="image profil" className=" _lg" />
                        <img src='/images/avis-deces-sm.png' alt="image profil" className=" _sm" />
                    </div>
                    <div className="col-sm-7 form-container top-form">

                        <div className="form-group">
                            <label>Je souhaite faire paraître un avis de décès * :</label>
                            
                            <div className="alternate-radio-buttons">
                                <ButtonRadio
                                    type="radio"
                                    _id="radioOp1"
                                    name="testament"
                                    value="1"
                                    checked={this.state.displayObituary }
                                    onChange={this.handleOnChange.bind(this, "displayObituary")}
                                    label="Oui"
                                />
                                <ButtonRadio
                                    type="radio"
                                    _id="radioOp2"
                                    name="testament"
                                    value="0"
                                    checked={ !this.state.displayObituary }
                                    onChange={this.handleOnChange.bind(this, "displayObituary")}
                                    label="Non"
                                />
                            </div>
                        </div>

                        {    // IF DISPLAY OBITUARY    
                            this.state.displayObituary &&
                            <div>
                                <div className="btn-add" onClick={this.addNewspapers} />
                                <label>Dans le journal ou les journaux suivants * :</label>
                                {this.state.newspapers &&  Array.isArray(this.state.newspapers) && this.state.newspapers.map((item, i) =>
                                    <div key={i}>
                                        {i > 0 &&
                                            <div className='btn-remove' onClick={() => this.removeItem(i)}>X</div>
                                        }
                                        <Field
                                            type="text"
                                            name={i}
                                            _className={"form-control newspapers " + this.state.error.newspapers}
                                            value={item}
                                            onChange={this.newspapersOnChange}
                                            error={this.state.error.newspapers}
                                            errorMessage="Veuillez entrer le nom d'un journal."
                                            placeholder="Veuillez entrer le nom d'un journal"
                                        />
                                    </div>
                                )}
                                <Textarea
                                    _className={"form-control obituary-text " + this.state.error.obituaryText}
                                    placeholder="900 caractères maximum - espaces compris"
                                    value={this.state.obituaryText}
                                    onChange={this.handleOnChange.bind(this, "obituaryText")}
                                    rows="8"
                                    error={this.state.error.obituaryText}
                                    errorMessage=" Veuillez entrer le texte de votre avis de décès."
                                    label="Je propose le texte suivant pour mon avis de décès * :"
                                />
                            </div>
                            // END DISPLAY OBITUARY
                        }
                        <div className="required-txt"> * Champs obligatoires</div>
                    </div>
                    <div className="col-sm-12 form-container align-center">
                        <div className="button-container">

                            <button type="submit" className="btn btn-outline-primary" onClick={this.props.back}>ANNULER</button>
                            <button type="submit" className="btn btn-primary">Suivant ></button>
                        </div>
                    </div>
                </div>
            </form >
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ObituaryPage/ObituaryForm.js